import { render, staticRenderFns } from "./CalendarStringFormat.vue?vue&type=template&id=1b8dc524&"
import script from "./CalendarStringFormat.vue?vue&type=script&lang=js&"
export * from "./CalendarStringFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports